import { render, staticRenderFns } from "./UserGlobalAlert.vue?vue&type=template&id=5c4fb980&"
import script from "./UserGlobalAlert.vue?vue&type=script&lang=js&"
export * from "./UserGlobalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports